import { getConfig } from './config'

const removeOidcQueryParams = (url: string) => {
  return url
    .replace(/([?&])(code|scope|state|session_state)=[^&]*/g, (match, separator) => (separator === '?' ? '?' : ''))
    .replace(/\?&/, '?')
    .replace(/\?$/, '')
}

export const getOidcConfig = () => ({
  authority: getConfig().KEYCLOAK_AUTHORITY,
  client_id: getConfig().KEYCLOAK_CLIENT_ID,
  redirect_uri: removeOidcQueryParams(location.href),
  post_logout_redirect_uri: location.origin,
  silent_redirect_uri: location.origin,
  revokeTokensOnSignout: true,
  onSigninCallback: () => {
    history.replaceState(null, window.name, removeOidcQueryParams(location.href))
  },
})
